import Popup from "./Popup";

export default function Popup10MinsWarning({
  isOpen,
  onPrimaryClick,
  onSecondaryClick,
  onClose,
}: {
  isOpen: boolean;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
  onClose: () => void;
}) {
  return (
    <Popup
      heading={
        <div>
          10分後にクーポンは自動的に
          <br />
          「利用済み」となります
        </div>
      }
      subheading="ご利用の際は時間内にお手続きを完了してください。"
      primaryButtonLabel="続ける"
      secondaryButtonLabel="戻る"
      onPrimaryClick={onPrimaryClick}
      onSecondaryClick={onSecondaryClick}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}
